import api from '@/api/api.js'

export default {
    getRapportCaisse(data) {
        const promise = api.comptabilite().post('/rapports/rapport-caisse', data)
        return promise.then((response) => response.data)
    },
}